import routes from 'app/rover/routes';

export default {
  routes,
};
